import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Select,
  Text,
  Heading,
  Button,
  useToast,
  useColorModeValue,
  Flex,
  VStack,
} from "@chakra-ui/react";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { Tutor } from "../Common/types";


interface TokenPayload {
    sub: string;
    role_id: number;
    tenant_id: number;
    exp?: number;
  }

const ReviewTutor = () => {

    const buttonBg = useColorModeValue(
        'linear-gradient(to right, blue.50, blue.100)',
        'linear-gradient(to right, blue.600, blue.700)'
      );
      const buttonHoverBg = useColorModeValue(
        'blue.200',
        'blue.500'
      );
    

  const { tutor_id } = useParams<{ tutor_id: string }>();

  const cardbg = useColorModeValue("gray.50", "gray.700");

  const [courseId, setCourseId] = useState<number | null>(null);

  const [selectedTenant, setSelectedTenant] = useState<number | null>(null);

    // Function to get tenant_id from the token
    const getTenantIdFromToken = (token: string): number | null => {
        try {
          const decoded: TokenPayload = jwtDecode<TokenPayload>(token);
          return decoded.tenant_id || null;
        } catch (error) {
          console.error("Error decoding token:", error);
          return null;
        }
      };

  // Assuming the `Tutor` type is already imported
const [tutor, setTutor] = useState<Tutor>({
    tutor_id :0,
    tenant_id:0,
    
    given_name : "",
    middle_name : "",
    surname : "",

    email : "",
    contact_no : "",
    gender : "",
    address : "",
    suburb : "",
    postcode : "",
    
    emergency_contact_name : "",
    emergency_contact_no : "",
    emergency_contact_relationship : "",

    date_of_birth :null,
    highest_qualification : "",

    is_active : true,
    actioned_by: "",
    created_at: new Date(), // Current timestamp for creation
    updated_at: new Date(), // Current timestamp for update
    user_id:0,
  });

  const toast = useToast();



  const fetchTutor = async () => {
    try {
        const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';
       
      const response = await axios.get(`${apiurl}/tutor/${tutor_id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      setTutor(response.data);
      console.log("Tutor Data Fetched", response.data)
    } catch (error) {
      console.error("Failed to load enrolled students", error);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const tenantId = getTenantIdFromToken(token) ?? 0; // Use 0 if tenantId is null
      console.log("Tenant ID:", tenantId);
  
      setTutor((prevDetails) => ({
        ...prevDetails, // Preserve other fields
        tenant_id: tenantId, // Update tenant_id
      }));
  
      setSelectedTenant(tenantId);

      if (Number(tutor_id) > 0)
      {
        console.log("Tutor Id:",tutor_id);
        fetchTutor();
      }

    }
  }, [tutor_id]);
  

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setTutor((prev) => ({ ...prev, [name]: value }));
  };
  

  const handleTimeChange = (time: string, name: string): void => {
    setTutor((prev) => ({ ...prev, [name]: `${time}:00` }));
  };
  
  const handleDateChange = (date: string, name: string): void => {
    setTutor((prev) => ({
      ...prev,
      [name]: date ? new Date(date) : null,  // Convert only if non-empty, else store as null
    }));
  };
  

   const handleSaveTutor = async () => {
    if (Number(tutor_id) > 0)
        { 
            handleUpdateTutor();
        }
        else
        {
            handleCreateTutor();
        }


   }

  const handleCreateTutor = async () => {
    console.log("Tutor Details sent to backend for processing",tutor);
    try {
        const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';
        const response = await axios.post(`${apiurl}/create-tutor`, tutor, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        //setCourses(response.data);
        toast({ title: "Tutor Successfully created" });
      } catch (error) {
        
        toast({ title: "Error creating tutor", status: "error" });
      }
  };

  const handleUpdateTutor = async () => {
    console.log("Tutor Details sent to backend for processing",tutor);

    try {
        const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';

        const response = await axios.put(`${apiurl}/update-tutor/${tutor_id}`, tutor, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        //setCourses(response.data);
        toast({ title: "Tutor Successfully updated" });
      } catch (error) {
        
        toast({ title: "Error updating tutor", status: "error" });
      }
  };

  return (
    <Box as="main" mx="auto" p={10} >

    <VStack>
    <Heading size={"md"}>Tutor Details</Heading>
    </VStack>

        <Box mt={4} bgColor={cardbg} borderRadius="sm" p={4} boxShadow="lg">
            <Text mb={4} fontSize="sm" fontWeight="bold">Identity Details</Text>
            <VStack spacing={4} align="stretch">
                <FormControl id="given_name" isRequired>
                    <Input
                    name="given_name"
                    placeholder="Given Name*"
                    size="sm"
                    value={tutor.given_name}
                    onChange={handleInputChange}
                    />

                </FormControl>

                <FormControl id="middle_name" >

                    <Input
                    name="middle_name"
                    placeholder="Middle Name*"
                    size="sm"
                    value={tutor.middle_name}
                    onChange={handleInputChange}
                    />
             
                </FormControl>

                <FormControl id="surname" isRequired>

                    <Input
                    name="surname"
                    placeholder="Surname*"
                    size="sm"
                    value={tutor.surname}
                    onChange={handleInputChange}
                    />
       
                </FormControl>

                <FormControl id="gender" isRequired>

                    <Select
                    placeholder="Select Gender*"
                    name="gender"
                    size="sm"
                    value={tutor.gender}
                    onChange={handleInputChange}
                    >
                    <option value="Female">Female</option>
                    <option value="Male">Male</option>
                    </Select>
                </FormControl>

                 <FormControl id="date_of_birth" isRequired>
                <Flex align="center" gap={4}>
                    <FormLabel minWidth="100px" mb="0" fontSize={"sm"}>Date of Birth</FormLabel>
                    <Input
                    type="date"
                    size="sm"
                    onChange={(e) => handleDateChange(e.target.value, "date_of_birth")}
                    value={tutor.date_of_birth ? new Date(tutor.date_of_birth).toISOString().split('T')[0] : ''}
                    />
                </Flex>
                </FormControl> 

{/*               <FormControl id="date_of_birth" isRequired>
                <Flex align="center" gap={4}>
                  <FormLabel minWidth="100px" mb="0" fontSize={"sm"}>Date of Birth</FormLabel>
                  <Input
                    type="date"
                    size="sm"
                    onChange={(e) => handleDateChange(e.target.value, "date_of_birth")}
                    value={tutor.date_of_birth instanceof Date 
                      ? tutor.date_of_birth.toISOString().split("T")[0] 
                      : ""
                    }
                  />
                </Flex>
              </FormControl> */}


                <FormControl id="highest_qualification" isRequired>
                    <Input
                    name="highest_qualification"
                    placeholder="Highest Qualification*"
                    size="sm"
                    value={tutor.highest_qualification}
                    onChange={handleInputChange}
                    />
   
                </FormControl>

                </VStack>
                </Box>


        <Box mt={4} bgColor={cardbg} borderRadius="sm" p={4} boxShadow="lg">
            <Text mb={4} fontSize="sm" fontWeight="bold">Contact Details</Text>
            <VStack spacing={4} align="stretch">
                <FormControl id="email" isRequired>
    
                    <Input
                    name="email"
                    type="email"
                    placeholder="Email*"
                    size="sm"
                    value={tutor.email}
                    onChange={handleInputChange}
                    />
              
                </FormControl>

                <FormControl id="contact_no" isRequired>
                    <Input
                    name="contact_no"
                    placeholder="Contact No*"
                    size="sm"
                    value={tutor.contact_no}
                    onChange={handleInputChange}
                    />
               
                </FormControl>
            </VStack>
            </Box>
                
        <Box mt={4} bgColor={cardbg} borderRadius="sm" p={4} boxShadow="lg">
            <Text mb={4} fontSize="sm" fontWeight="bold">Address Details</Text>
            <VStack spacing={4} align="stretch">
                <FormControl id="address" isRequired>
                    <Input
                    name="address"
                    placeholder="Address*"
                    size="sm"
                    value={tutor.address}
                    onChange={handleInputChange}
                    />
           
                </FormControl>

                <FormControl id="suburb" isRequired>

                    <Input
                    name="suburb"
                    placeholder="Suburb*"
                    size="sm"
                    value={tutor.suburb}
                    onChange={handleInputChange}
                    />
       
                </FormControl>

                <FormControl id="postcode" isRequired>

                    <Input
                    name="postcode"
                    placeholder="Postcode*"
                    size="sm"
                    value={tutor.postcode}
                    onChange={handleInputChange}
                    />
            
                </FormControl>

            </VStack>
            </Box>

        <Box mt={4} bgColor={cardbg} borderRadius="sm" p={4} boxShadow="lg">
            <Text mb={4} fontSize="sm" fontWeight="bold">Emergency Contact Details</Text>
            <VStack spacing={4} align="stretch">
                <FormControl id="emergency_contact_name" isRequired>
                    <Input
                    name="emergency_contact_name"
                    placeholder="Emergency Contact Name*"
                    size="sm"
                    value={tutor.emergency_contact_name}
                    onChange={handleInputChange}
                    />
   
                </FormControl>

                <FormControl id="emergency_contact_no" isRequired>
                    <Input
                    name="emergency_contact_no"
                    placeholder="Emergency Contact No*"
                    size="sm"
                    value={tutor.emergency_contact_no}
                    onChange={handleInputChange}
                    />
       
                </FormControl>

                <FormControl id="emergency_contact_relationship" isRequired>

                    <Input
                    name="emergency_contact_relationship"
                    placeholder="Emergency Contact Relationship*"
                    size="sm"
                    value={tutor.emergency_contact_relationship}
                    onChange={handleInputChange}
                    />

                </FormControl>

            </VStack>
            </Box>

        {/* Save Button */}
        <Box textAlign="left" mt={4}>
            <Button mb={2} colorScheme="blue" size="sm" borderRadius={"sm"} onClick={handleSaveTutor}>
            Save Tutor
            </Button>
        </Box>

    </Box>
  );
};

export default ReviewTutor;
